// extracted by mini-css-extract-plugin
export var danger = "_12-6";
export var lightPink = "_12-a";
export var medium = "_12-j";
export var nearSquare = "_12-m";
export var neutralBlue = "_12-8";
export var neutralYellow = "_12-7";
export var noCapitalize = "_12-1";
export var normal = "_12-2";
export var pill = "_12-0";
export var primary = "_12-3";
export var primaryLight = "_12-4";
export var shadow = "_12-n";
export var small = "_12-k";
export var solidBlack = "_12-i";
export var solidGreen = "_12-d";
export var solidLightBlue = "_12-f";
export var solidNavy = "_12-e";
export var solidOrange = "_12-h";
export var solidPink = "_12-g";
export var solidRed = "_12-b";
export var solidWhite = "_12-9";
export var solidYellow = "_12-c";
export var success = "_12-5";
export var xsmall = "_12-l";